import '../style/main.css';
import { List } from './List';

export const Main = () => {
    return (
        <main>
            <List />
        </main>
    );
};